<div class="container">
  <div class="bubble bubble-bottom-left">
    {{ message }}
  </div>
  <div class="image">
    <img [src]="imgSrc" />
  </div>
</div>
